export enum GrantHolder {
	PASS_OWNER = 'PASS_OWNER',
	PASS_CHILD = 'PASS_CHILD',
}
